export default {
    computed: {
        limits() {
            return this.$store.getters['auth/limits'];
        },
        isPro() {
            return this.$store.getters['auth/isPro'];
        },
        isStarter() {
            return this.$store.getters['auth/isStarter'];
        }
    },
    
    methods: {
        /**
         * Verifica se pode criar um novo cliente
         */
        async canCreateCustomer() {
            const maxCustomers = this.limits.max_customers;
            
            // Pro é ilimitado
            if (maxCustomers === null) {
                return { allowed: true };
            }
            
            try {
                // Usar action centralizada
                const data = await this.$store.dispatch('utils/ActionGetCustomersCount');
                const currentCount = data.count;
                
                if (currentCount >= maxCustomers) {
                    return {
                        allowed: false,
                        error: 'Limite de clientes atingido para o plano Starter',
                        current: currentCount,
                        limit: maxCustomers
                    };
                }
                
                return { allowed: true };
            } catch (error) {
                console.error('Erro ao verificar limite de clientes:', error);
                // Em caso de erro, permitir (backend validará)
                return { allowed: true };
            }
        },
        
        /**
         * Verifica se pode criar uma nova sessão
         */
        async canCreateSession() {
            const maxSessions = this.limits.max_monthly_sessions;
            
            // Pro é ilimitado
            if (maxSessions === null) {
                return { allowed: true };
            }
            
            try {
                // Usar action centralizada
                const data = await this.$store.dispatch('utils/ActionGetMonthlySessionsCount');
                const currentCount = data.count;
                
                if (currentCount >= maxSessions) {
                    return {
                        allowed: false,
                        error: 'Limite de sessões mensais atingido para o plano Starter',
                        current: currentCount,
                        limit: maxSessions
                    };
                }
                
                return { allowed: true };
            } catch (error) {
                console.error('Erro ao verificar limite de sessões:', error);
                return { allowed: true };
            }
        },
        
        /**
         * Verifica se pode criar um novo contrato para o cliente
         */
        async canCreateContract(customerId) {
            const maxContracts = this.limits.max_contracts_per_customer;
            
            // Pro é ilimitado
            if (maxContracts === null) {
                return { allowed: true };
            }
            
            try {
                // Usar action centralizada
                const data = await this.$store.dispatch('utils/ActionGetActiveContractsCount', customerId);
                const activeContracts = data.count;
                
                if (activeContracts >= maxContracts) {
                    return {
                        allowed: false,
                        error: 'Limite de contratos ativos por cliente atingido para o plano Starter',
                        current: activeContracts,
                        limit: maxContracts
                    };
                }
                
                return { allowed: true };
            } catch (error) {
                console.error('Erro ao verificar limite de contratos:', error);
                return { allowed: true };
            }
        },
        
        /**
         * Verifica se pode fazer upload de imagem
         */
        canUploadImage() {
            const maxUploads = this.limits.max_image_uploads;
            
            if (maxUploads === null) {
                return { allowed: true };
            }
            
            if (maxUploads === 0) {
                return {
                    allowed: false,
                    error: 'Upload de imagens disponível apenas no plano Premium',
                    limit: 0
                };
            }
            
            return { allowed: true };
        },
        
        /**
         * Mostra erro de limite com opção de upgrade
         */
        showLimitError(limitCheck) {
            this.$swal({
                icon: 'warning',
                title: 'Limite Atingido',
                html: `
                    <p>${limitCheck.error}</p>
                    ${limitCheck.current !== undefined ? `<p>Uso atual: ${limitCheck.current}/${limitCheck.limit}</p>` : ''}
                `,
                confirmButtonText: 'Fazer Upgrade para Premium',
                showCancelButton: true,
                cancelButtonText: 'Fechar',
                confirmButtonColor: '#4CAF50'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.showUpgradeInfo();
                }
            });
        },
        
        /**
         * Mostra informações sobre upgrade
         */
        showUpgradeInfo() {
            this.$swal({
                icon: 'info',
                title: 'Plano Premium',
                html: `
                    <h3>Benefícios do Plano Premium:</h3>
                    <ul style="text-align: left; padding-left: 20px;">
                        <li>✅ Clientes ilimitados</li>
                        <li>✅ Sessões ilimitadas</li>
                        <li>✅ Contratos ilimitados</li>
                        <li>✅ Upload de imagens</li>
                        <li>✅ Integração com Google Calendar</li>
                        <li>✅ Integração com WhatsApp</li>
                        <li>✅ Gestão de despesas</li>
                        <li>✅ Comprovantes</li>
                        <li>✅ Notificações</li>
                        <li>✅ Histórico completo</li>
                    </ul>
                    <p style="margin-top: 20px;">Entre em contato para fazer upgrade!</p>
                `,
                confirmButtonText: 'Entendi',
                confirmButtonColor: '#4CAF50'
            });
        }
    }
};
